import { useParams } from 'react-router-dom';

import { useOrganizationId } from '@/hooks/useSwr';
import { addQueryParams } from '@/utils/add-query-params';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function HubTenantCrumb(props: Partial<BreadcrumbData>) {
  const { owner } = useParams();
  const organizationId = useOrganizationId();
  const innerPath =
    props.path === '#' ? '#' : addQueryParams(props.path, { organizationId });
  if (!owner) return null;
  return <Breadcrumb name={owner} path={innerPath} />;
}
